import React from 'react';
import {BluesnapDialog} from './components/BluesnapDialog';

export async function renderBluesnapDialog(root, data) {
    const bluesnapDialogRef: React.RefObject<typeof BluesnapDialog> = React.createRef();
    const props = data?.Procedure?.length && data.Procedure[0];

    root.render(<BluesnapDialog ref={bluesnapDialogRef} {...props} />);
    return bluesnapDialogRef;
}
